import React from 'react'
import styled from '@emotion/styled'
import { FlexRowDiv, FlexDiv } from '../generic/Basics'
import { grayLight20, fontSizeSmall, fontSize2XSmall, greenBase } from '../../constants/principles'
import Icon from '@kbbcomponentlibrary/icon'
import { breakpoints } from '../../constants'

const ICODefList = ({ dealerIsDirectToKBB }) => (
  <>
    <TextDiv>How is an Instant Cash Offer different from the Trade-In Range?</TextDiv>
    <StyledUl>
      <StyledLi>Unique to your car</StyledLi>
      <StyledLi>Based on your specific details and condition</StyledLi>
      <StyledLi>It's an actual offer for cash or a trade-in</StyledLi>
      {!dealerIsDirectToKBB && <StyledLi>Redeemable at only participating dealers</StyledLi>}
    </StyledUl>
  </>
)

export default ({ isDesktop, url, dealerIsDirectToKBB }) => (
  <PADiv isDesktop={isDesktop}>
    <HeaderDiv isDesktop={isDesktop}>
      <span>
        <StyledIcon type="Checkbox" colorFill={greenBase} size={36} />
        Your Offer Is Within the Kelley Blue Book&#174; Trade-In Range
      </span>
      {isDesktop && <ICODefList dealerIsDirectToKBB={dealerIsDirectToKBB} />}
    </HeaderDiv>
    <iframe title="price-advisor" frameBorder={0} scrolling="no" src={url + '&DisplayTI=false'} width={isDesktop ? 330 : 280} height={isDesktop ? 415 : 365}>
      Your browser does not support iframes.
    </iframe>
    {!isDesktop && <ICODefList dealerIsDirectToKBB={dealerIsDirectToKBB} />}
  </PADiv>
)

const PADiv = styled(FlexRowDiv)`
  border-top: 1px solid ${grayLight20};
  justify-content: space-between;
  align-items: ${p => (p.isDesktop ? 'flex-start' : 'center')};
  margin-top: 40px;
  flex-direction: ${p => (p.isDesktop ? 'row' : 'column')};
  width: 100%;
`
const HeaderDiv = styled(FlexDiv)`
  font-size: ${p => (p.isDesktop ? fontSizeSmall : fontSize2XSmall)};
  font-weight: bold;
  align-items: flex-start;
  padding-top: ${p => (p.isDesktop ? 64 : 32)}px;
  padding-left: 32px;
`
const StyledIcon = styled(Icon)`
  vertical-align: bottom;
`
const StyledUl = styled.ul`
  list-style-type: circle;
  font-size: ${fontSize2XSmall};
  padding-left: 16px;
  margin-top: 8px;
`
const TextDiv = styled.div`
  padding-top: 24px;
  font-size: ${fontSize2XSmall};
  font-weight: bold;
`
const StyledLi = styled.li`
  font-weight: normal;
  padding-left: 4px;
  padding-bottom: 8px;
`
